import React, { useEffect, useState } from 'react';
import Login from '../Login';
import Register from '../Register';
import YandexLoginButton from './YandexLoginButton';
import s from '../../styles/Home.module.css';

function AuthModal({ isOpen, onClose, isRegistering, setIsRegistering }) {
  const [registrationPrivacyChecked, setRegistrationPrivacyChecked] = useState(false);
  const [registrationMarketingChecked, setRegistrationMarketingChecked] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  return (
    <div className={s.modalOverlay} onClick={onClose}>
      <div className={s.authModal} onClick={(e) => e.stopPropagation()}>
        <div className={s.authSwitcher}>
          <button
            type="button"
            onClick={() => setIsRegistering(false)}
            className={!isRegistering ? s.active : s.noactive}
          >
            Вход
          </button>
          /
          <button
            type="button"
            onClick={() => setIsRegistering(true)}
            className={isRegistering ? s.active : s.noactive}
          >
            Регистрация
          </button>
        </div>

        <div className={s.authForm}>
          {isRegistering ? (
            <Register
              privacyConsent={registrationPrivacyChecked}
              marketingConsent={registrationMarketingChecked}
              onPrivacyChange={setRegistrationPrivacyChecked}
              onMarketingChange={setRegistrationMarketingChecked}
            />
          ) : (
            <Login />
          )}
        </div>

        <div className={s.yandexAuthBlock}>
          <div className={s.yandexAuthLabel}>Или войдите через:</div>
          <YandexLoginButton disabled={isRegistering && !registrationPrivacyChecked} />
        </div>
      </div>
    </div>
  );
}

export default AuthModal;
